import styled, {css} from 'styled-components'
import * as AvatarPrimitive from '@radix-ui/react-avatar'

type AvatarRootProps = {
    $size: 'xs' | 'sm' | 'md' | 'lg'
}

export const makeAvatarSizeStyle = {
    xs: css`
        width: 20px;
        height: 20px;
        font-size: 10px;
    `,
    sm: css`
        width: 24px;
        height: 24px;
        font-size: 12px;
    `,
    md: css`
        width: 40px;
        height: 40px;
        font-size: 20px;
    `,
    lg: css`
        width: 48px;
        height: 48px;
        font-size: 20px;
    `
}

export const AvatarRoot = styled(AvatarPrimitive.Root)<AvatarRootProps>`
    ${({theme: {palette}, $size}) => css`
        ${makeAvatarSizeStyle[$size]};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        user-select: none;
        border-radius: 100%;
        overflow: hidden;
        background: ${palette.neutral['100']};
        border: 1px ${palette.neutral['300']};
        flex-shrink: 0;
    `}
`

export const StyledAvatarWrapper = styled.div(
    ({theme: {spacing, palette, shadows}}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        padding: ${spacing * 0.5}px;
        background-color: ${palette.neutral['white']};
        border-radius: 100%;
        outline: 1px solid ${palette.neutral['200']};
        box-shadow: ${shadows.sm};
    `
)
